export default __webpack_public_path__ + "static/media/shopping_cart_.bb181fca.svg";